<template>
  <b-card no-body class="classification-card">
    <b-card-header class="classification-header">
      <div class="header-title">
        <i class="fas fa-tags mr-2"></i>
        <strong>Classificação</strong>
      </div>
      <div class="header-actions">
        <b-button
          v-if="canEdit"
          variant="primary"
          size="sm"
          @click="$emit('open')"
          >Editar
        </b-button>
      </div>
    </b-card-header>
    <b-card-body v-if="complaint.classification" class="classification-body">
      <ClassificationViewer
        :record="complaint"
        classification="receivingMeans"
        label="Meio de Recebimento"
      />
      <ClassificationViewer
        :record="complaint"
        classification="origin"
        label="Origem da Comunicação"
      />
      <ClassificationViewer
        :record="complaint"
        classification="reportingAgent"
        label="Agente Denunciante"
      />
      <ClassificationViewer
        :record="complaint"
        classification="level"
        label="Classificação/Classe Interna"
      />
      <ClassificationViewer
        :record="complaint"
        classification="nature"
        label="Natureza"
      />
      <ClassificationViewer
        :record="complaint"
        classification="responsibleDepartment"
        label="Área responsável pelo tratamento"
      />
      <ClassificationViewer
        :record="complaint"
        classification="involvedDepartment"
        label="Setor da Ocorrência"
      />
      <ClassificationViewer
        :record="complaint"
        classification="businessGroup"
        label="Empresa do Grupo"
      />
      <ClassificationViewer
        :record="complaint"
        classification="businessUnit"
        label="Unidade/Posto/Filial"
      />
      <ClassificationViewer
        :record="complaint"
        classification="relatedProject"
        label="Contrato/Projeto"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import ClassificationViewer from "@/views/commons/ClassificationViewer";

export default {
  name: "ClassificationCard",
  components: { ClassificationViewer },
  props: {
    complaint: { type: Object, required: true },
    canEdit: { type: Boolean, default: false },
  },
};
</script>

<style></style>
